import * as React from 'react'

import {emptyObject} from '../../../../utils/empty'
import type {KeyValue} from '../../../../utils/object'

export type TreeExpandState = KeyValue<string, boolean>

/*
 * Solves the following issues:
 * 1. Storing of the search query
 * 2. Storing of two separate expand states
 *   - default expand state
 *   - expand state when searching
 * 3. Switching between expand states
 * 4. Clearing of the search expand state on search
 */
export function useTreeState(
  initialState: TreeExpandState,
): [TreeExpandState, (arg0: string, arg1: boolean) => void, string, (arg0: string) => void] {
  const [expandState, setExpandState] = React.useState<TreeExpandState>(initialState)
  const [searchExpandState, setSearchExpandState] = React.useState<TreeExpandState>(initialState)
  const [searchQuery, setSearchQuery] = React.useState('')
  const searching = searchQuery !== ''
  const currentExpandState = searching ? searchExpandState : expandState
  const setCurrentExpandState = searching ? setSearchExpandState : setExpandState
  return [
    currentExpandState,
    (id: string, expanded: boolean) =>
      setCurrentExpandState({...currentExpandState, [id]: expanded}),
    searchQuery,
    query => {
      setSearchQuery(query)
      setSearchExpandState(emptyObject)
    },
  ]
}

export const SEARCHABLE_PROJECTS_NUMBER = 10

export function useShowState(): [boolean, () => void, () => void] {
  const [show, setShow] = React.useState(false)
  const onShow = React.useCallback(() => setShow(true), [setShow])
  const onHide = React.useCallback(() => {
    setShow(false)
  }, [setShow])

  return [show, onShow, onHide]
}
